import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../i18n';
import Utils from '../../../utils/utils';
import { matchPath } from 'react-router';

const ModificationSent = ({ confirmCallback }) => {
    return (
        <div className="modify-exchange-confirm">
            <img className="tick" src={`${Utils.getAssetsDomain()}/images/website/common/confirm_tick.svg`} />
            <h1>{i18n.t('exchange:modification_request_sent_title')}</h1>
            <div
                dangerouslySetInnerHTML={{
                    __html: i18n.t('exchange:modification_request_sent_text')
                }}
            />
            <button
                onClick={(e) => {
                    confirmCallback(e);
                }}
                className="button button--yellow"
                id="return-to-conversation"
            >
                {matchPath('/:locale?/conversations/:id/infos', window.location.pathname)
                    ? i18n.t('exchange:return_to_conversation_cta')
                    : i18n.t('common:close')}
            </button>
        </div>
    );
};

ModificationSent.propTypes = {
    confirmCallback: PropTypes.func.isRequired
};

export default ModificationSent;
